import { action, computed, makeAutoObservable, observable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { logWithState } from '../functions/console.function';
import { useStoreCommon } from '../hooks/useStore.hook';
import { RootStoreMobX } from './root.store';

type DialogType = {
  title: string;
  description: string | React.ReactNode;
  confirm: () => void;
};

export type DialogStoreContextType = {
  selected: DialogType;
};

export class DialogStoreMobX {
  rootStore: RootStoreMobX;
  @observable public load: boolean = false;
  @observable public selected: DialogStoreContextType['selected'] | null = null;

  constructor(rootStore: RootStoreMobX) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  @computed get hasSelected(): boolean {
    return this.selected !== null;
  }

  @action public init() {
    this.load = true;
  }

  @action public select(dialog: DialogType | null) {
    if (this.load) {
      this.selected = dialog;
    }
  }
}

export const ConfigDialog = observer(
  ({ children }: { children: React.ReactNode }) => {
    const { DialogStore } = useStoreCommon();

    useEffect(() => {
      if (!DialogStore.load) {
        logWithState({ state: 'INFO', value: 'ConfigDialog init' });
        DialogStore.init();
      }

      if (DialogStore.load) {
        logWithState({ state: 'INFO', value: 'ConfigDialog load' });
      }
    }, [DialogStore.load]);

    return DialogStore.load ? children : null;
  },
);
